import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';
//import PhoneMaskInput from 'vue-phone-mask-input';
import utilsPlugin from '@/libs/utils/plugin'
import { applyCompanyWindowGlobals } from '@/libs/companyGlobals'
import './global-components'
import { ToastPlugin, ModalPlugin, BootstrapVue } from 'bootstrap-vue';
import { patchBootstrapVueModelAssign } from '@/libs/bootstrapVueCompatPatch'

// Bootstrap-Vue's built-in Vue 3 patch targets el._assign; Vue 3.3.5+ uses Symbol("_assign").
patchBootstrapVueModelAssign()

//import '@/libs/portal-vue'
//import PortalVue from 'portal-vue';
//import '@/libs/toastification'
import '@/libs/acl'
import ability from '@/libs/acl/ability'
import VueCookies from "vue-cookies";
import Toast from "vue-toastification";
import '@vue/compat';
import "vue-toastification/dist/index.css";
//import VueHtmlToPaper from 'vue-html-to-paper';
import  VueHtmlToPaper from './libs/VueHtmlToPaper';
import { initBarcodeScanner } from '@/libs/barcodeScanner';

require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

window.isAgva = window.location.hostname.includes('agva');
window.currency_symbol = '$';
window.companyCountryCode = 'us';
window.companyPhoneCode = '';
window.timezone_name = null;
window.time_format = '12h';
window.companyLogo = '/static_images/no_image.png';

const sweetalertOptions = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
    icon: 'warning', // success
};

const printOptions = {
    name: '_blank',
    specs: [
        'fullscreen=no',
        'titlebar=yes',
        'scrollbars=yes'
    ],
};

// Mount immediately — do not block first paint on api/user (401 for guests was delaying home ~4s).
const app = createApp(App)
    .use(router)
    .use(store)
    .use(BootstrapVue, {
      BCalendar: {
        // Default BV format includes weekday ("Wednesday, October 7, 2026").
        dateFormatOptions: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        },
      },
      BFormDatepicker: {
        dateFormatOptions: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        },
      },
    })
    .use(ModalPlugin)
    .use(ToastPlugin)
    .use(VueCookies, { expire: '7d' })
    .use(Toast)
    .use(VueSweetalert2, sweetalertOptions)
    .use(VueHtmlToPaper, printOptions)
    .use(utilsPlugin);

app.config.globalProperties.$swal = app.config.globalProperties.$swal;
app.provide('$swal', app.config.globalProperties.$swal);

app.config.globalProperties.$cookies = app.config.globalProperties.$cookies;

window.$cookies = app.config.globalProperties.$cookies;
window.$swal = app.config.globalProperties.$swal;

app.mount('#app');
initBarcodeScanner();

store.dispatch('auth/bootstrap', ability).then((response) => {
    if (response !== null && response.company != null) {
        applyCompanyWindowGlobals(response.company);
    }

    const staffRoles = ['Admin', 'Company Owner', 'Supervisor']
    const modulesReady = response && staffRoles.includes(response.role)
        ? store.dispatch('modulesRegistry/loadModules').catch(() => null)
        : Promise.resolve()

    return modulesReady.then(() => response)
}).then((response) => {
    if (!response) {
        return
    }

    // Apply auth redirects that may have been skipped while the public page painted early.
    const route = router.currentRoute.value
    if (route?.name === 'home' && (response.role === 'Supervisor' || response.role === 'Admin')) {
        router.replace({ name: 'calendar' }).catch(() => {})
    } else if (route?.meta?.redirectIfLoggedIn) {
        router.replace({ name: 'profile' }).catch(() => {})
    }

    import('@/libs/sessionWatch').then(({ startSessionWatch }) => {
        startSessionWatch()
    }).catch(() => {})
}).catch(() => {})
